import { LocationContextService } from '../location-context.service';

export function LocationContextReset(locationContextService: LocationContextService): () => Promise<boolean> {
    return (): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            try {
                locationContextService.resetLocationContextDataAndSelection();
                resolve(true);
            } catch (e) {
                reject(e);
                throw new Error(e);
            }
        });
    };
}
